// Simple route constants
export const ROUTES = {
  // Auth routes
  LOGIN: '/login',
  WAITLIST: '/waitlist',

  // Dashboard routes
  DASHBOARD: '/dashboard',
  DASHBOARD_CHARACTERS: '/dashboard/characters',
  DASHBOARD_CHARACTERS_CREATE: '/dashboard/characters/create',
  DASHBOARD_STORY_TEMPLATES: '/dashboard/story-templates',
  DASHBOARD_STORY_TEMPLATES_CREATE: '/dashboard/story-templates/create',
  DASHBOARD_GENERATED_STORIES: '/dashboard/generated-stories',
  DASHBOARD_ROLE_TEMPLATES: '/dashboard/role-templates',
  DASHBOARD_STYLE_TEMPLATES: '/dashboard/style-templates',
  DASHBOARD_STYLE_TEMPLATES_CREATE: '/dashboard/style-templates/create',
  DASHBOARD_ROLE_TEMPLATES_CREATE: '/dashboard/role-templates/create',

  // Story routes
  CREATE_STORY: (templateId: string) => `/create-story/${templateId}`,
  CREATE_CUSTOM_TEMPLATE: '/create/custom',

  // Checkout route
  CHECKOUT: '/checkout',

  // Default routes
  HOME: '/',
  NOT_FOUND: '/*',
} as const;

// Type for route parameters
export type RouteParams = {
  templateId: string;
};
